import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
// Side-effect import only: constructing the singleton is what starts the
// connection. Keeps the socket in the eager bundle even if routes go lazy.
import '../services/alphalendWebsocket';
const AlphalendWebSocketContext = createContext(undefined);
export const useAlphalendWebSocket = () => {
    const context = useContext(AlphalendWebSocketContext);
    if (context === undefined) {
        throw new Error('useAlphalendWebSocket must be used within an AlphalendWebSocketProvider');
    }
    return context;
};
// No connect() here on purpose: the alphalendWebSocketService singleton connects
// itself at import time (its constructor runs activity detection, which checks
// connection state), reconnects on activity/visibility changes, and connects
// lazily from subscribe(). Calling connect() from an effect here only raced with
// the import-time attempt and hit the service's "already connecting" guard.
export const AlphalendWebSocketProvider = ({ children, }) => {
    return (_jsx(AlphalendWebSocketContext.Provider, { value: {}, children: children }));
};
